import { useNestedGrid } from "./NestedGridContext";

export function NestedGridViewer() {
    const { svgContent, handleDownload, seed, nestingLevels } = useNestedGrid();

    return (
        <div className="panel-viewer blob-field-viewer">
            <div className="path-tool-preview">
                <div className="svg-scroll-wrapper">
                    <div
                        className="nested-grid-viewer-svg"
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: SVG is built programmatically
                        dangerouslySetInnerHTML={{ __html: svgContent }}
                    />
                </div>
                <div className="path-tool-footer">
                    <p className="path-tool-meta">
                        Seed {seed} · {nestingLevels} nesting level
                        {nestingLevels !== 1 ? "s" : ""}
                    </p>
                    <button
                        type="button"
                        className="generic-button"
                        onClick={handleDownload}
                    >
                        Download result SVG
                    </button>
                </div>
            </div>
        </div>
    );
}
